import { unwrapDek, wrapDek } from './dek';

/**
 * Re-wraps a document DEK for a recipient's public key.
 * The owner unwraps with their private key in the browser, then this helper
 * wraps the raw DEK for the recipient — zero-knowledge on the server.
 */
export async function rewrapDekForRecipient(
  ownerWrappedDek: string,
  ownerPrivateKey: CryptoKey | string,
  recipientPublicKeyPem: string,
): Promise<string> {
  const dek = await unwrapDek(ownerWrappedDek, ownerPrivateKey);
  return wrapDek(dek, recipientPublicKeyPem);
}
